import { useNavigate } from 'react-router';

import PATH from '@/constants/path';
import useUser from '@/hooks/use-user.hook';
import { Badge } from '../badge';

import Menu from './components/menu';

const Header = (): React.JSX.Element => {
  const { isSignedIn } = useUser();
  const navigate = useNavigate();

  const isInHomePage = window.location.pathname === PATH.INDEX;

  return (
    <header className="w-full flex py-8 px-8 md:px-20 items-center justify-center">
      <div className="flex w-full flex-wrap items-center justify-between gap-2">
        <div className="flex flex-col items-end">
          {/* Logo and Brand Name */}
          <div
            onClick={() =>
              isSignedIn
                ? navigate(PATH.DASHBOARD.INDEX)
                : isInHomePage
                  ? window.scrollTo(0, 0)
                  : navigate(PATH.INDEX)
            }
            className="flex items-center gap-4 cursor-pointer"
          >
            <img className="max-w-36 h-auto" alt="Logo" src="../../logo.svg" />
          </div>
          <Badge className="bg-white border border-primary text-primary focus:text-primary hover:text-primary focus:bg-white hover:bg-white self-end cursor-default text-xs px-2 mt-1 font-regular">
            Beta
          </Badge>
        </div>
        <Menu isSignedIn={isSignedIn} />
      </div>
    </header>
  );
};

export default Header;
